/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MediaUiARecordIcon16Light } from './MediaUiARecordIcon16Light';
import { MediaUiARecordIcon16Regular } from './MediaUiARecordIcon16Regular';
import { MediaUiARecordIcon16Solid } from './MediaUiARecordIcon16Solid';
import { MediaUiARecordIcon20Light } from './MediaUiARecordIcon20Light';
import { MediaUiARecordIcon20Regular } from './MediaUiARecordIcon20Regular';
import { MediaUiARecordIcon20Solid } from './MediaUiARecordIcon20Solid';
import { MediaUiARecordIcon24Regular } from './MediaUiARecordIcon24Regular';
import { MediaUiARecordIcon24Solid } from './MediaUiARecordIcon24Solid';
import { MediaUiARecordIcon32Regular } from './MediaUiARecordIcon32Regular';
import { MediaUiARecordIcon64Regular } from './MediaUiARecordIcon64Regular';
var sizes = {
    16: {
        light: MediaUiARecordIcon16Light,
        regular: MediaUiARecordIcon16Regular,
        solid: MediaUiARecordIcon16Solid,
    },
    20: {
        light: MediaUiARecordIcon20Light,
        regular: MediaUiARecordIcon20Regular,
        solid: MediaUiARecordIcon20Solid,
    },
    24: {
        regular: MediaUiARecordIcon24Regular,
        solid: MediaUiARecordIcon24Solid,
    },
    32: {
        regular: MediaUiARecordIcon32Regular,
    },
    64: {
        regular: MediaUiARecordIcon64Regular,
    },
};
export var MediaUiARecordIcon = forwardRef('MediaUiARecordIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
